var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus-squared",
    d: "M14.19 20H5.8C4.26164 19.9947 2.78794 19.3806 1.70109 18.2918C0.614232 17.2031 0.00263417 15.7284 0 14.19V5.80999C0.00263417 4.27163 0.614232 2.79687 1.70109 1.70814C2.78794 0.619415 4.26164 0.0052776 5.8 -6.63736e-06H14.18C14.943 -0.00132099 15.6987 0.147658 16.4042 0.438424C17.1096 0.72919 17.7508 1.15605 18.2912 1.69463C18.8317 2.23321 19.2607 2.87296 19.5539 3.57736C19.8471 4.28176 19.9987 5.03701 20 5.79999V14.18C20.0013 14.9438 19.852 15.7004 19.5606 16.4065C19.2692 17.1125 18.8415 17.7542 18.3018 18.2948C17.7622 18.8353 17.1213 19.2642 16.4157 19.5568C15.7101 19.8494 14.9538 20 14.19 20ZM15 8.99999H11V4.99999C11 4.73478 10.8946 4.48042 10.7071 4.29289C10.5196 4.10535 10.2652 3.99999 10 3.99999C9.73478 3.99999 9.48043 4.10535 9.29289 4.29289C9.10536 4.48042 9 4.73478 9 4.99999V8.99999H5C4.73478 8.99999 4.48043 9.10535 4.29289 9.29289C4.10536 9.48042 4 9.73478 4 9.99999C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 9.99999C16 9.73478 15.8946 9.48042 15.7071 9.29289C15.5196 9.10535 15.2652 8.99999 15 8.99999Z",
    fill: "#CC9C33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0a4f5f2089bc01367f56909b416d3306.svg";
export { ForwardRef as ReactComponent };